import { render, staticRenderFns } from "./RowClients.vue?vue&type=template&id=72651c38&"
import script from "./RowClients.vue?vue&type=script&lang=js&"
export * from "./RowClients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports